import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Link2 } from "lucide-react";

export const jobLabel = (j) => `${j.job_name || j.job_number}${j.job_name ? ` (${j.job_number})` : ""}`;

export function ParentJobSelect({ jobId, value, onChange, testid = "parent-job-select" }) {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/jobs", { params: { active: true } }).then((r) => setJobs(r.data)).catch(() => {}); }, []);
  const opts = jobs.filter((j) => j.id !== jobId && !j.parent_job_id);
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Not linked" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Not linked</SelectItem>
        {opts.map((j) => <SelectItem key={j.id} value={j.id}>{jobLabel(j)} · {j.customer_name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function JobLinks({ job, canEdit, reload }) {
  const save = async (pid) => {
    try { await api.patch(`/jobs/${job.id}`, { parent_job_id: pid }); toast.success(pid ? "Linked to main job" : "Link removed"); reload(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="card-industrial p-4 mb-6 grid md:grid-cols-2 gap-4" data-testid="job-links">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground mb-1 flex items-center gap-1"><Link2 className="w-3.5 h-3.5" />Linked to main job (costing)</div>
        {job.linked_jobs?.length ? <p className="text-sm text-muted-foreground">This is a main job. Its costing includes the linked jobs.</p>
          : canEdit ? <ParentJobSelect jobId={job.id} value={job.parent_job_id} onChange={save} />
          : <p className="text-sm">{job.parent_job ? jobLabel(job.parent_job) : "Not linked"}</p>}
        {job.parent_job && <Link to={`/jobs/${job.parent_job.id}`} className="text-xs text-primary hover:underline mt-1 inline-block" data-testid="parent-job-link">Open main job {jobLabel(job.parent_job)}</Link>}
      </div>
      <div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground mb-1">Jobs linked to this job</div>
        {job.linked_jobs?.length ? (
          <div className="flex flex-wrap gap-2" data-testid="linked-jobs-list">
            {job.linked_jobs.map((l) => <Link key={l.id} to={`/jobs/${l.id}`} className="text-xs px-2 py-1 rounded border border-border hover:border-primary transition-colors" data-testid={`linked-job-${l.job_number}`}>{jobLabel(l)}</Link>)}
          </div>
        ) : <p className="text-sm text-muted-foreground">None</p>}
      </div>
    </div>
  );
}
